import { ApolloClient } from '@apollo/client';

import {
  GENERATE_AVANT_PASS_TOKEN,
  GENERATE_MULTIPASS_TOKEN,
} from '../apollo/api/mutations';
import {
  AuthErrorResponse,
  AuthGateway,
  GenerateAvantPassTokenResponse,
  GenerateMultipassTokenResponse,
} from '../types/Auth';
import {
  GeneratedGenerateAvantPassTokenInput,
  GeneratedGenerateAvantPassTokenMutation,
  GeneratedGenerateAvantPassTokenMutationVariables,
  GeneratedGenerateMultipassTokenMutation,
  GeneratedGenerateMultipassTokenMutationVariables,
} from '../types/generated';
import { captureError } from '../utils/capture';

// this constant has to match the value in the orders service.
const AVANT_PASS_CUSTOM_ATTRIBUTE_KEY = 'avant_pass_token';

/** @deprecated Use graphql generated hooks  */
class AvantArteAuthGateway implements AuthGateway {
  constructor(
    private avantArteClient: ApolloClient<any>,
    // @ts-expect-error
    private shopifyClient?: ApolloClient<any>,
  ) {}

  public async generateShopifyMultipassToken(
    returnTo: string,
  ): Promise<GenerateMultipassTokenResponse | AuthErrorResponse> {
    const { data, errors } = await this.avantArteClient.mutate<
      GeneratedGenerateMultipassTokenMutation,
      GeneratedGenerateMultipassTokenMutationVariables
    >({
      mutation: GENERATE_MULTIPASS_TOKEN,
      variables: {
        returnTo,
      },
    });

    if (errors && !data) {
      return {
        error: {
          code: 'UNAUTHORIZED',
        },
      };
    }

    return { token: data!.generateMultipassToken.token };
  }

  public async generateAvantPassToken(
    input: GeneratedGenerateAvantPassTokenInput,
  ): Promise<GenerateAvantPassTokenResponse> {
    const { data, errors } = await this.avantArteClient.mutate<
      GeneratedGenerateAvantPassTokenMutation,
      GeneratedGenerateAvantPassTokenMutationVariables
    >({
      mutation: GENERATE_AVANT_PASS_TOKEN,
      variables: {
        input,
      },
    });
    if (errors?.length) {
      const err = new Error(JSON.stringify(errors[0]));
      captureError(err, {
        tags: {
          function: 'generateAvantPassToken',
        },
      });
      throw err;
    }

    const { token } = data!.generateAvantPassToken;
    return {
      customAttribute: {
        key: AVANT_PASS_CUSTOM_ATTRIBUTE_KEY,
        value: token,
      },
      token,
    };
  }
}

export default AvantArteAuthGateway;
